import { SharedFileRequestContextType } from "@wingspanhq/wingspan-api-sdk";

// accepts the raw wire value too — the v1 settings reads (no v3 twin yet)
// and the v3 runtime reads share the same context-type strings
export function selectorIsSharedFileNotNoneContext(
  contextType: SharedFileRequestContextType | string | undefined
): boolean {
  return !!contextType && SharedFileRequestContextType.NONE !== contextType;
}
